import { PageHeader, useFetch } from "../../components/crm/ui";
import { AlertTriangle } from "lucide-react";

export default function Inventory() {
  const { data: materials } = useFetch("/materials");
  const { data: vendors } = useFetch("/vendors");
  return (
    <div data-testid="inventory-page">
      <PageHeader overline="Operations" title="Inventory" />
      <div className="border border-[#E2E4DC] bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-[0.25em] text-[#4A5568] border-b border-[#E2E4DC]">
              <th className="px-4 py-3">Code</th><th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Vendor</th>
              <th className="px-4 py-3 text-right">In Stock</th>
              <th className="px-4 py-3 text-right">Min</th>
              <th className="px-4 py-3 text-right">Δ</th>
              <th className="px-4 py-3 text-right">Value (₹)</th>
            </tr>
          </thead>
          <tbody>
            {materials.map((m) => {
              const low = m.quantity < m.min_quantity;
              const delta = m.quantity - m.min_quantity;
              const ven = vendors.find((v) => v.id === m.vendor_id);
              return (
                <tr key={m.id} className={"border-b border-[#E2E4DC] " + (low ? "bg-red-50/50" : "hover:bg-[#F4F5F0]")} data-testid={`inv-${m.code}`}>
                  <td className="px-4 py-3 font-mono">{m.code}</td>
                  <td className="px-4 py-3">{m.name}</td>
                  <td className="px-4 py-3 text-xs text-[#4A5568]">{ven?.name || "—"}</td>
                  <td className={"px-4 py-3 text-right font-mono " + (low ? "text-red-600 font-semibold" : "")}>
                    {low && <AlertTriangle className="w-3 h-3 inline mr-1" />} {m.quantity}
                  </td>
                  <td className="px-4 py-3 text-right font-mono">{m.min_quantity}</td>
                  <td className={"px-4 py-3 text-right font-mono " + (delta < 0 ? "text-red-600" : "text-emerald-700")}>{delta > 0 ? "+" : ""}{delta}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{(m.quantity * m.unit_price).toLocaleString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
